/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareRoundedMinus = createReactComponent(
  "square-rounded-minus",
  "IconSquareRoundedMinus",
  [
    ["path", { d: "M9 12h6", key: "svg-0" }],
    [
      "path",
      {
        d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconSquareRoundedMinus as default };
//# sourceMappingURL=IconSquareRoundedMinus.js.map
